import React, {Component} from 'react';
import {APIClient} from "../../utils/APIClient";
import logo from '../../images/logo_dashbo_purple.svg';
import logotipo from '../../images/logotipo_dashbo_purple.svg';
import {API_URL} from "../../settings/local_settings";
import {AgencyFormFieldError} from "./AgencyFormFieldError";
import {gaEvents} from "../../utils/GA4Events";
import {metaEvents} from "../../utils/MetaPixelEvents";
import {Spinner} from "../Spinner";
import {withRouterParams} from "../../utils/withRouterParams";
import { withTranslation } from 'react-i18next';
import {LocalStorage} from "../../utils/LocalStorage";

class AgencyRegister extends Component {
    constructor(props) {
        super(props);
        this.redirectAgencyConnections = this.redirectAgencyConnections.bind(this);
    }
    apiUrl() {
        return API_URL + 'agency-register/';
    }

    redirectAgencyConnections() {
        // Verificar si hay una URL guardada para redirigir después del registro
        const redirectUrl = LocalStorage.getRedirectUrl();
        if (redirectUrl) {
            LocalStorage.clearRedirectUrl();
            this.props.history.push(redirectUrl);
        } else {
            // Comportamiento por defecto: redirigir a conexiones con onboarding
            this.props.history.push({
                pathname: '/agency/conections',
                state: { showOnBoarding: true }
            });
        }
    }
    render() {
        return (
            <div className="app-content">
                <TranslatedAgencyRegisterSidebar/>
                <TranslatedAgencyForm submit_url={this.apiUrl()} 
                            redirectAgencyConnections={this.redirectAgencyConnections}/>

            </div>
        );
    }
}

class AgencyRegisterSidebar extends Component {
    render() {
        const { t } = this.props;
        return (
            <div className="agency-register login-sidebar">
                <img src={logo} className="app-logo" alt="logo"/>
                <img src={logotipo} className="app-logo-name" alt="logotipo"/>
                <p className="tagline">{t('agency_register.tagline')}</p>
            </div>
        );
    }
}

class AgencyForm extends Component {
    constructor(props) {
        super(props);
        this.state = {
            saving: false,
            countries: [],
            errors: []
        };
        this.handleSubmit = this.handleSubmit.bind(this);
        this.getCountries = this.getCountries.bind(this);
    }

    getCountries() {
        new APIClient(API_URL + 'countries/').call('GET').then((data) => {
            if (data.status === 'ERROR') {
                alert(data['error_message']);
            } else if (data.status === 'OK') {
                this.setState({
                    countries: data['countries']
                });
            }
        });
    }

    UNSAFE_componentWillMount() {
        this.getCountries();
    }

    handleSubmit(event) {
        event.preventDefault();
        this.setState({saving: true});
        new APIClient(this.props.submit_url).call('POST', {
            'amount_of_people': event.target.amount.value,
            'name': event.target.name.value,
            'creator_name': event.target.creatorname.value,
            'country': event.target.country.value,
            'phone_number': event.target.phonenumber.value,
            'website': event.target.website.value,
            'referral_code': event.target.referral_code.value,

        }).then((data) => {
            this.setState({saving: false});
            if (data.status === 'ERROR') {
                let errors = JSON.parse(data.errors);
                this.setState({
                    errors: errors
                });
            } else if (data.status === 'OK') {
                gaEvents.eventAgencyCreated();
                metaEvents.eventAgencyCreated();
                this.props.redirectAgencyConnections();
            }
        })
    }

    renderSaveButton() {
        const { t } = this.props;
        if (!this.state.saving) {
            return <input type="submit" value={t('agency_register.create_button')} className="btn -submit -long"/>
        } else {
            return <Spinner color="positive small"/>;
        }
    }

    render() {
        const { t } = this.props;
        if (this.state.countries.length > 0) {
            const countries_options = this.state.countries.map((country) => {
                return (
                    <option key={country[0]} value={country[0]} selected={country[0] === 'AR'}>
                        {country[1]}
                    </option>
                );
            });

            return (
                <div className="agency-register login-content">
                    <div className="login-box">
                        <h2 className="form-title">{t('agency_register.form_title')}</h2>
                        <form onSubmit={this.handleSubmit}>
                            <div className="mb-3">
                                <label className="form-label"><span title={t('agency_register.required_field')}>*</span>{t('agency_register.agency_name')}</label>
                                <input
                                    name="name" type="text"
                                    required="required"
                                    maxLength="50"
                                    className="form-control"
                                />
                                <AgencyFormFieldError errors={this.state.errors} fieldName='name'/>
                            </div>

                            <div className="mb-3">
                                <label className="form-label">{t('agency_register.your_name')}</label>
                                <input
                                    name="creatorname" type="text"
                                    maxLength="100"
                                    placeholder=""
                                    className="form-control"
                                />
                                <AgencyFormFieldError errors={this.state.errors} fieldName='creator_name'/>
                            </div>

                            <div className="row mb-3">
                                <div className="col-lg-6">
                                    <label className="form-label"><span title={t('agency_register.required_field')}>*</span>{t('agency_register.employee_count')}</label>
                                    <input name="amount" type="number" required="required" min={1} className="form-control"/>
                                    <AgencyFormFieldError errors={this.state.errors} fieldName='amount_of_people'/>
                                </div>
                                <div className="col-lg-6">
                                    <label className="form-label"><span title={t('agency_register.required_field')}>*</span>{t('agency_register.country')}</label>
                                    <select name="country" required="required" className="form-select">
                                        {countries_options}
                                    </select>
                                    <AgencyFormFieldError errors={this.state.errors} fieldName='country'/>
                                </div>
                            </div>
                            <div className="row mb-3">
                                <div className="col-lg-6">
                                    <label className="form-label">{t('agency_register.phone')}</label>
                                    <input name="phonenumber" type="text" className="form-control"/>
                                    <AgencyFormFieldError errors={this.state.errors} fieldName='phone_number'/>
                                </div>
                                <div className="col-lg-6">
                                    <label className="form-label"><span title={t('agency_register.required_field')}>*</span>{t('agency_register.website')}</label>
                                    <input name="website" type="text" required="required" className="form-control"/>
                                    <AgencyFormFieldError errors={this.state.errors} fieldName='website'/>
                                </div>
                            </div>
                            <div className="mb-3">
                                <label className="form-label">{t('agency_register.referral_code')}</label>
                                <input name="referral_code" type="text" maxLength="50" placeholder="" className="form-control" />
                            </div>
                            <div className="submit-row">
                                {this.renderSaveButton()}
                            </div>

                        </form>
                    </div>
                </div>
            );
        } else {
            return <p>{t('agency_register.loading')}</p>
        }
    }
}

const TranslatedAgencyRegisterSidebar = withTranslation()(AgencyRegisterSidebar);
const TranslatedAgencyForm = withTranslation()(AgencyForm);

export { TranslatedAgencyRegisterSidebar as AgencyRegisterSidebar, TranslatedAgencyForm as AgencyForm };

export default withRouterParams(withTranslation()(AgencyRegister));
